export default {
      id: "saving-3-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#saving-3",
      toString: function () {
        return this.url;
      }
    }